import { render } from "./StorageView.vue?vue&type=template&id=e48197e6&scoped=true"
import script from "./StorageView.vue?vue&type=script&lang=js"
export * from "./StorageView.vue?vue&type=script&lang=js"

import "./StorageView.vue?vue&type=style&index=0&id=e48197e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e48197e6"]])

export default __exports__